export default __webpack_public_path__ + "static/media/bg-layer@2x.e4bff279.png";